import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";

export default function EmailVerifiedRoute() {
  const { isAuthenticated, status, user } = useAuth();
  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";

  if (status === "booting") return null;
  if (!isAuthenticated) return null;

  if (!isEmailVerified) {
    return <Navigate to="/verificar-email" replace />;
  }

  return <Outlet />;
}
